import { lddGlobalSessionInfo } from "../Components/navigationTypes";
import { lddStateObject } from "../redux/reducer";
import { debounce } from "./debounce";
const Preference = {
    get: (SESSION_INFO: lddGlobalSessionInfo): Promise<lddStateObject["Preference"]> => {
        const {
            appProvinceShort,
            sid,
            firm
        } = SESSION_INFO;
        return fetch(`/${process.env.REACT_APP_RWAPI_ENDPOINT}/api/${appProvinceShort}/${firm.id}/preference?SessionID=${sid}`)
            .then(async (response) => {
                if (response.status !== 200) {
                    return {};
                } else {
                    const data = await response.json();
                    return data.result;
                }
            })
    },

    set: (setting: lddStateObject["Preference"], SESSION_INFO: lddGlobalSessionInfo) => {
        const {
            appProvinceShort,
            sid,
            firm
        } = SESSION_INFO;
        debounce(() => {
            fetch(`/${process.env.REACT_APP_RWAPI_ENDPOINT}/api/${appProvinceShort}/${firm.id}/set/preference?SessionID=${sid}`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(setting)
                })
                .then(async (response) => {
                    if (response.status !== 200) {
                        return {};
                    } else {
                        const data = await response.json();
                        return data.result;
                    }
                })
        }, 500)
    }
}

export default Preference;